import type { FC } from "react"

import { useRecoilValue, useSetRecoilState } from "recoil"
import styled from "styled-components"

import { notificationsState } from "~/containers/Proposal/state/notifications/notifications"

import { ReactComponent as WarningIcon } from "@svg/warning-outline.svg"

import { notificationBarIsOpenState } from "./QueryErrorModal"

const NotificationIconWrapper = styled.div`
  svg {
    path {
      fill: var(--danger);
    }
  }
`

export const NotificationIcon: FC<{
  style?: React.CSSProperties
}> = ({ style }) => {
  const setNotificationBarIsOpen = useSetRecoilState(notificationBarIsOpenState)
  const notifications = useRecoilValue(notificationsState)

  return (
    <NotificationIconWrapper>
      {notifications.length > 0 && (
        <WarningIcon
          onClick={() => setNotificationBarIsOpen((prev) => !prev)}
          style={{
            cursor: `pointer`,
            ...style,
          }}
        />
      )}
    </NotificationIconWrapper>
  )
}

const DesignerIconWrapper = styled.div`
  flex-shrink: 0;
  width: fit-content;
  display: flex;
  align-items: center;
  svg {
    path {
      fill: var(--danger);
    }
  }
`

export const NotificationIconForDesigner: FC = () => {
  const setNotificationBarIsOpen = useSetRecoilState(notificationBarIsOpenState)
  const notifications = useRecoilValue(notificationsState)

  return (
    <>
      {notifications.length > 0 && (
        <DesignerIconWrapper>
          <WarningIcon
            onClick={() => setNotificationBarIsOpen((prev) => !prev)}
            style={{
              cursor: `pointer`,
            }}
          />
        </DesignerIconWrapper>
      )}
    </>
  )
}
